import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@icons/search.png'
import _imports_1 from '@icons/close.png'


const _hoisted_1 = {
  class: "make-model-trim",
  "data-component-name": "make-model-trim"
}
const _hoisted_2 = { "data-role": "facet-filter" }
const _hoisted_3 = { class: "mmt-body" }
const _hoisted_4 = { class: "v-row ma-0 py-4" }
const _hoisted_5 = {
  key: 0,
  class: "v-col-7 py-0 px-6 d-flex crumb-container"
}
const _hoisted_6 = ["data-for"]
const _hoisted_7 = {
  key: 0,
  id: "modelTitle",
  class: "d-flex"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "px-1" }, "/", -1)
const _hoisted_9 = ["data-for"]
const _hoisted_10 = {
  key: 1,
  id: "trimTitle",
  class: "d-flex"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "px-1" }, "/", -1)
const _hoisted_12 = ["data-for"]
const _hoisted_13 = {
  key: 1,
  class: "v-col-12 px-6 py-0 d-flex"
}
const _hoisted_14 = { class: "mmt-search" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Search Icon"
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "",
  alt: "close icon"
}, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  id: "makeList",
  class: "mmt-list"
}
const _hoisted_21 = {
  id: "modelList",
  class: "mmt-list"
}
const _hoisted_22 = {
  id: "trimList",
  class: "mmt-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterMenuLineItem = _resolveComponent("FilterMenuLineItem")!
  const _component_HierarchicalFacetList = _resolveComponent("HierarchicalFacetList")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createVNode(_component_FilterMenuLineItem, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expandFilter())),
            isSelected: !!_ctx.facetFilters[_ctx.facetMetaData.mmt.key],
            title: _ctx.$t('Make/Model/Trim')
          }, null, 8, ["isSelected", "title"])
        ], 512), [
          [_vShow, !_ctx.makeModelTrimFilterSelected && !_ctx.filterSelected]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (!_ctx.searchPhrase.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", {
                    id: "makeTitle",
                    class: _normalizeClass(!_ctx.makeSelected ? 'active-crumb' : ''),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectMake())),
                    "data-for": _ctx.makeTitle
                  }, _toDisplayString(_ctx.makeTitle), 11, _hoisted_6),
                  (_ctx.modelSelected || _ctx.trimSelected)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("div", {
                          class: _normalizeClass(!_ctx.modelSelected ? 'active-crumb ' : ''),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectModel())),
                          "data-for": _ctx.modelTitle
                        }, _toDisplayString(_ctx.modelTitle), 11, _hoisted_9)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.trimSelected)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("div", {
                          class: _normalizeClass(!_ctx.trimSelected ? 'active-crumb' : ''),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectTrim())),
                          "data-for": _ctx.trimTitle
                        }, _toDisplayString(_ctx.trimTitle), 11, _hoisted_12)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.searchTitle), 1))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              class: "search-input",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchPhrase) = $event)),
              placeholder: "Search make or model",
              onKeyup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.triggerDelayedSearch && _ctx.triggerDelayedSearch(...args))),
              type: "text"
            }, null, 544), [
              [_vModelText, _ctx.searchPhrase]
            ]),
            (_ctx.searchPhrase.length < 2)
              ? (_openBlock(), _createElementBlock("label", _hoisted_15, _hoisted_17))
              : (_openBlock(), _createElementBlock("label", {
                  key: 1,
                  class: "pointer",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.resetSearchPhrase())),
                  onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.resetSearchPhrase()), ["enter"])),
                  tabindex: "0"
                }, _hoisted_19, 32))
          ]),
          _createVNode(_Transition, { name: "slide" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_20, [
                _createVNode(_component_HierarchicalFacetList, {
                  class: "facet-list",
                  modelValue: _ctx.makesModel,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.makesModel) = $event)),
                  data: _ctx.makes,
                  onSelect: _ctx.loadModels,
                  "sub-menu": 'Model'
                }, null, 8, ["modelValue", "data", "onSelect"])
              ], 512), [
                [_vShow, _ctx.makeSelected]
              ])
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "slide" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_21, [
                _createVNode(_component_HierarchicalFacetList, {
                  class: "facet-list",
                  modelValue: _ctx.modelsModel,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modelsModel) = $event)),
                  data: _ctx.models,
                  onSelect: _ctx.loadTrims,
                  "sub-menu": 'Trim',
                  ref: "modelsRef"
                }, null, 8, ["modelValue", "data", "onSelect"])
              ], 512), [
                [_vShow, _ctx.modelSelected]
              ])
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "slide" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_22, [
                _createVNode(_component_HierarchicalFacetList, {
                  class: "facet-list",
                  modelValue: _ctx.trimsModel,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.trimsModel) = $event)),
                  data: _ctx.trims,
                  ref: "trimsRef"
                }, null, 8, ["modelValue", "data"])
              ], 512), [
                [_vShow, _ctx.trimSelected]
              ])
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, _ctx.makeModelTrimFilterSelected]
        ])
      ])
    ]),
    _: 1
  }))
}